
import { useEffect, useState } from "react";
import { useQuery } from '@tanstack/react-query';
import AttachmentImage from "components/modals/attachmentmodal/attachmentlist/attachmentimage";
import { getFileType } from "@/services/api"
import { QueryKeys } from "enums/query-keys.enum";
import Select from "components/select";
import useTranslation from "../../../../hooks/useTranslate.hook";
import { UploadTypes, UploadTypesInt } from '@/enums/upload-types.enum';


type AttachmentListType = {
    filesProp: FileList,
    removeFile?: Function,
    fileTypeSelect?: boolean,
    selectFileType?: Function,
    displayPreview?: boolean,
}

const AttachmentsList = ({ filesProp, removeFile, fileTypeSelect = false, selectFileType, displayPreview = false }: AttachmentListType) => {
    const { t } = useTranslation(["responses"]);
    const [files, setFiles] = useState<any>([]);

    const { data: dataFileFypes } = useQuery({
        queryKey: [QueryKeys.FileTypes],
        queryFn: () => getFileType(),
        select: (data: any) => {
            const transformedData = data.map((type: any) => ({ ...type, name: t(`backend_api.file_types.${type.name}`) }));
            return transformedData;
        },
        gcTime: 1200000, staleTime: 600000
    });

    const mapType = (val: string): number | null => {
        if (val == UploadTypes.CV) return UploadTypesInt.CV;
        if (val == UploadTypes.CoverLetter) return UploadTypesInt.CoverLetter;
        if (val == UploadTypes.ProfilePhoto) return UploadTypesInt.ProfilePhoto;
        if (val == UploadTypes.Other) return UploadTypesInt.Other;
        return null;
    }

    useEffect(() => {
        setFiles(filesProp);
    }, [filesProp]);
    
    return (
        <>
            <div className={fileTypeSelect ? "c-communication-email-attachment__attachmnet_list_select" : "c-communication-email-attachment__attachmnet_list"}>
                {files && files?.map((item: any, index: number) => {
                    return (
                        <div key={"image_div_" + index + item.file.name }>
                            <AttachmentImage
                                fileProp={item.file}
                                keyProp={index}
                                key={"image_" + index + item.file.name}
                                name={item.file.name}
                                removeFile={(fileName: any) => removeFile && removeFile(fileName)}
                                displayName={!fileTypeSelect}
                                displayDeleteButton={!!removeFile}
                                displayPreviewButton={displayPreview}
                                allDocs={files}
                            />
                            {fileTypeSelect &&
                                <div key={"dev_" + index} className="c-communication-email-attachment__attachmnet_list_name_select">
                                    <div><span className="c-communication-email-attachment__attachmnet_list_name_select--name">{item.file.name}</span></div>
                                    <Select
                                        key={item.file.name + "_select"}
                                        title={t("type")}
                                        placeholder={t("select_type")}
                                        data={dataFileFypes}
                                        defaultValue={mapType(item.type)}//set it only for Others
                                        onChange={(val: any) => { if (selectFileType != null) selectFileType(item.file.name, val.id); }}
                                    />
                                </div>
                            }
                        </div>
                    )
                })}
            </div>
        </>
    )
};

export default AttachmentsList;